import { useEffect, useState } from 'react';
import { filter, map } from 'rxjs';

import { Markdown } from '@client:common/Markdown';

import { FormControl } from '../../models/FormControl';

import './ValidationErrorList.dark.scss';
import './ValidationErrorList.light.scss';

interface Props {
  formLabel: string;
  formControl: FormControl<unknown>;
}

export function ValidationErrorList({ formControl, formLabel }: Props) {
  const [validationErrors, setValidationErrors] = useState([]);

  useEffect(() => {
    const subscription = formControl
      .validityChanges()
      .pipe(
        filter(() => !formControl.isPristine()),
        map(() => {
          if (formControl.errors === null) {
            return [];
          }
          return Object.entries(formControl.errors)
            .sort((leftEntry, rightEntry) =>
              leftEntry[0].localeCompare(rightEntry[1])
            )
            .map(([validationName, errorMessage]) => {
              switch (validationName) {
                case 'checkNotEmpty':
                  return `${formLabel} is **required**`;
                case 'checkValidEmail':
                  return `Invalid ${formLabel}`;
                case 'checkConfirmedPassword':
                  return 'Passwords don\'t match';
                default:
                  return ` ${errorMessage}`;
              }
            });
        })
      )
      .subscribe({
        next: setValidationErrors
      });
    return () => {
      subscription.unsubscribe();
    };
  }, [formControl, formLabel, setValidationErrors]);

  if (validationErrors.length === 0) {
    return null;
  }
  return (
    <ul className='validation-error-list'>
      {validationErrors.map((message, i) => (
        <li
key={i}
className='validation-error-list__message'>
          <Markdown>{message}</Markdown>
        </li>
      ))}
    </ul>
  );
}
